import { render, staticRenderFns } from "./ZahnarztPraxisFormular.vue?vue&type=template&id=22960876&"
import script from "./ZahnarztPraxisFormular.vue?vue&type=script&lang=js&"
export * from "./ZahnarztPraxisFormular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports